import { Icon } from "../design-system/Icon";
import { Button } from "../design-system/Button";
import type { TableView } from "../lib/useTableView";

/** Barra de búsqueda + filtro por estado para una tabla (item 8). */
export function TableToolbar({ view, searchPlaceholder }: { view: TableView; searchPlaceholder?: string }): JSX.Element {
  return (
    <div className="row" style={{ gap: 8, padding: "var(--sp-3) var(--sp-4)", borderBottom: "1px solid var(--border)", flexWrap: "wrap" }}>
      <label className="search" style={{ flex: 1, minWidth: 200 }}>
        <Icon name="search" size={16} />
        <input
          type="search"
          value={view.query}
          placeholder={searchPlaceholder ?? "Buscar…"}
          aria-label="Buscar en la tabla"
          onChange={(e) => view.setQuery(e.target.value)}
        />
      </label>
      {view.statuses.length > 1 ? (
        <select
          className="pd-input"
          style={{ width: "auto", minWidth: 140 }}
          value={view.statusFilter}
          aria-label="Filtrar por estado"
          onChange={(e) => view.setStatusFilter(e.target.value)}
        >
          <option value="">Todos los estados</option>
          {view.statuses.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      ) : null}
      {view.hasDates ? (
        <div className="row" style={{ gap: 6, alignItems: "center" }}>
          <span className="faint" style={{ fontSize: 12.5 }}>Fecha</span>
          <input className="pd-input" style={{ width: "auto" }} type="date" value={view.dateFrom} aria-label="Desde (fecha)" max={view.dateTo || undefined} onChange={(e) => view.setDateFrom(e.target.value)} />
          <span className="faint" style={{ fontSize: 12.5 }}>a</span>
          <input className="pd-input" style={{ width: "auto" }} type="date" value={view.dateTo} aria-label="Hasta (fecha)" min={view.dateFrom || undefined} onChange={(e) => view.setDateTo(e.target.value)} />
          {view.dateFrom || view.dateTo ? (
            <Button variant="ghost" size="sm" onClick={() => { view.setDateFrom(""); view.setDateTo(""); }}>Limpiar</Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

/** Pie de paginación con contador y navegación anterior/siguiente (item 8). */
export function TablePagination({ view }: { view: TableView }): JSX.Element | null {
  if (view.filteredTotal === 0) return null;
  return (
    <div className="row" style={{ justifyContent: "space-between", alignItems: "center", padding: "var(--sp-3) var(--sp-4)", borderTop: "1px solid var(--border)", flexWrap: "wrap", gap: 8 }}>
      <span className="faint" style={{ fontSize: 12.5 }}>
        {view.pageStart}–{view.pageEnd} de {view.filteredTotal}
        {view.filteredTotal !== view.total ? ` (filtrado de ${view.total})` : ""}
      </span>
      {view.pageCount > 1 ? (
        <div className="row" style={{ gap: 6 }}>
          <Button variant="secondary" size="sm" disabled={view.page === 0} onClick={() => view.setPage(view.page - 1)}>Anterior</Button>
          <span className="muted" style={{ fontSize: 12.5, alignSelf: "center" }}>Página {view.page + 1} de {view.pageCount}</span>
          <Button variant="secondary" size="sm" disabled={view.page >= view.pageCount - 1} onClick={() => view.setPage(view.page + 1)}>Siguiente</Button>
        </div>
      ) : null}
    </div>
  );
}
